export default "__VITE_ASSET__CG0ERNXy__"